import { all_routes as routes } from "@kanakku/feature-module/router/all_routes";

const item = (label: string, link: string, icon: string) => ({
  label,
  link,
  submenu: false,
  showSubRoute: false,
  icon,
  base: "frontent",
  materialicons: "start",
  dot: true,
  submenuItems: [] as [],
});

export const SidebarData = [
  {
    tittle: "Menu principal",
    icon: "airplay",
    showAsTab: true,
    separateRoute: false,
    submenuItems: [item("Tableau de bord", routes.adminDashboard, "element-45")],
  },
  {
    tittle: "Facturation",
    icon: "airplay",
    showAsTab: true,
    separateRoute: false,
    submenuItems: [
      {
        label: "Factures",
        link: "apps",
        submenu: true,
        showSubRoute: false,
        icon: "receipt-item5",
        base: "invoices",
        materialicons: "dashboard",
        dot: true,
        submenuItems: [
          { label: "Liste", link: routes.invoices, base: "invoices", customSubmenuTwo: false },
          { label: "Créer", link: routes.createInvoices, base: "invoices", customSubmenuTwo: false },
          { label: "Modèles", link: routes.invoiceTemplates, base: "Templates", customSubmenuTwo: false },
          { label: "Récurrentes", link: routes.recurringInvoices, base: "todo", customSubmenuTwo: false },
        ],
      },
      item("Avoirs", routes.creditNotes, "note5"),
      item("Clients", routes.customers, "profile-2user5"),
      item("Paiements", routes.payments, "money-recive5"),
      item("Paramètres", "/tenant/billing/settings", "setting5"),
    ],
  },
  {
    tittle: "Portail client",
    icon: "airplay",
    showAsTab: true,
    separateRoute: false,
    submenuItems: [item("Espace client", routes.customerDashboard, "user-octagon5")],
  },
  {
    tittle: "Rapports",
    icon: "airplay",
    showAsTab: true,
    separateRoute: false,
    submenuItems: [
      item("Rapport ventes", routes.salesReport, "chart5"),
      item("Synthèse paiements", routes.paymentSummary, "money-recive5"),
      item("Rapport clients", routes.customersReport, "profile-2user5"),
      item("Clients en retard", routes.customerDueReport, "warning-25"),
    ],
  },
];
